import React from 'react';
import {Radio,Modal,Input,Form,InputNumber,Popover,Icon} from 'antd';
import TipsView from 'components/TipsView';
import classnames from 'classnames';
import styles from './ItemLiveInterfaceTips.module.less';
const FormItem = Form.Item;
const TextArea = Input.TextArea;

const ACTION_MAKE_SURE = 2;
const ACTION_TIPS = 1;
const ACTION_NONE = 0;

const Actions = [
    {value:ACTION_MAKE_SURE,label:'enable confirmation mode',tips:{
        dec:'After opening, the user needs to read the content and cooperate with the action to agree:',
        img:require('image/scene/example-meglive-flash.png'),
        width: '282px',
        imgHeight:'165px'
    }},
    {value:ACTION_TIPS,label:'prompt mode',tips:{
        dec:'After opening, the interface will display prompt content:',
        img:require('image/scene/interface_example.png'),
        width: '282px',
        imgHeight:'165px'
    }},
    {value:ACTION_NONE,label:'turn off'}
];
const ActionsTextMap = [];
Actions.forEach(item=>{
    ActionsTextMap[item.value] = item.label;
});

//弹窗配置
export const FormMap = {
    [ACTION_MAKE_SURE]:[
        {
            label:'Action stage guide copy',
            key:'liveness_hint_message_active',
            placeholder:'Please enter',
            rules:[
                {required:true,message:'not nullable'},
                {max:100,message:'cannot be greater than 100 characters'}
            ]
        },
        {
            label:'Colorful stage prompt copy',
            key:'liveness_hint_message_flash',
            placeholder:'Please enter',
            rules:[
                {max:100,message:'cannot be greater than 100 characters'}
            ]
        }
    ],

    [ACTION_TIPS]:[{
        label:'prompt',
        key:'interface_prompt_text'
    }],
    [ACTION_NONE]:[]
};

// 2行全局提示
const MULTI_TIPS = {
    label:'prompt',
    key:'interface_prompt_text',
    placeholder:'Please enter (recommended within 120 characters)',
    multi:true,
    rules:[
        {required:true,message:'not nullable'},
        {
            validator:(rule, value, callback)=>{
                if(typeof value === 'undefined'){
                    callback();
                    return;
                };
                //分割换行
                const testArray = value.split('\n');
                if(testArray.length>3){
                    callback('enter at most 3 lines');
                }
                const maxLength = 120;
                let textCount = 0;

                for(let i=0;i<testArray.length;i++){
                    textCount = textCount + testArray[i].length;
                }
                if(textCount>maxLength){
                    callback(`recommended within ${120} characters`);
                }else{
                    callback();
                }

            }
        }
    ]
};

// props:
// hasMakeSure 是否存在确认模式


class ItemLiveInterfaceTips extends React.Component {

    state = {
        isShowTextModal:false,
        cacheAction:'' //缓存选项，弹窗确认后才真正设置
    }

    onRadioChange = (event)=>{
        const target = event.target;
        if(target.value !== ACTION_NONE){
            this.setState({
                isShowTextModal:true,
                cacheAction:target.value
            },()=>{
                this.props.form.resetFields();
            });
        }else{
            // 选择不开启，需要清空tips
            this.setState({isShowTextModal:false,cacheAction:target.value});
            this.props.onChange({
                action:target.value,
                tips:null
            });
        }
    }

    onTimeChange = (valueTime)=>{
        const {value} = this.props;
        const newValue = {...value};
        newValue.liveness_keep_time = valueTime;
        this.props.onChange(newValue);
    }


    onCloseTextModal = ()=>{
        // 如果关闭，清理已输入内容
        this.setState({
            isShowTextModal:false
        });

    }

    onSaveText = ()=>{
        this.props.form.validateFields((errors, values)=>{
            if(!errors){
                let liveness_keep_time = undefined;
                if(this.state.cacheAction === ACTION_MAKE_SURE){
                    liveness_keep_time = 2;
                }
                this.props.onChange({
                    action:this.state.cacheAction,
                    tips:values,
                    liveness_keep_time
                });
                this.setState({isShowTextModal:false});
            }
        });
    }

    onTipsChange = ()=>{
        const state = {isShowTextModal:true};
        state.cacheAction = this.props.value.action;
        this.setState(state,()=>{
            this.props.form.setFieldsValue(this.props.value.tips);
        });
    }


    render(){
        const {value = {},hasMakeSure} = this.props;
        const {getFieldDecorator} = this.props.form;
        const {action=0,tips={},liveness_keep_time} = value;
        const {isShowTextModal,cacheAction} = this.state;
        const modalTitle = ActionsTextMap[cacheAction];

        // 根据multilineTips 判断，插入多行还是单行
        const renderFormMap = {...FormMap};
        renderFormMap[ACTION_TIPS] = [MULTI_TIPS];
        const filterActions = Actions.filter(item=>{
            if(!hasMakeSure && item.value === ACTION_MAKE_SURE){
                return false;
            }
            return true;
        });
        return (
            <div>
                <Radio.Group
                    disabled={this.props.disabled}
                    onChange={this.onRadioChange}
                    value={action}
                >
                    {filterActions.map(item=>{
                        return <Radio
                            key={item.value}
                            value={item.value}
                            text={item.label}>
                            {item.label}
                            {item.tips &&<Popover
                                placement="rightTop"
                                arrowPointAtCenter
                                content={<TipsView textMap={item.tips}/>}
                            >
                                <Icon className={styles.tipsIcon} type="info-circle" theme="filled" />
                            </Popover>}
                        </Radio>;
                    })}
                </Radio.Group>
                {action !== ACTION_NONE && <div className={styles.tipsTextBg}>
                    {!this.props.disabled && <a className={styles.change} onClick={this.onTipsChange}>Revise</a>}
                    {
                        renderFormMap[action].map((item,index)=>{
                            const tipsText = classnames({
                                [styles.tipsText]:true,
                                [styles.tipsTextEmpty]:!tips[item.key]
                            });
                            return (
                                <div key={index} className={styles.tipsTextBox}>
                                    <div className={styles.tipsTextTop}>
                                        <img src={require('image/scene/icon/notice.svg')} /><span>{item.label}</span>
                                    </div>
                                    <div className={tipsText}>{tips[item.key] || 'empty'}</div>
                                </div>
                            );
                        })
                    }
                </div>}
                {action === ACTION_MAKE_SURE && <div className={styles.tipsTextBg}>
                    <div className={styles.tipsTextBox}>
                        <div className={styles.tipsTextTop}>
                            <img src={require('image/scene/icon/time.svg')} /><span>Please set the display time of the prompt copy before motion detection</span>
                        </div>
                        <div>
                            <InputNumber
                                disabled={this.props.disabled}
                                onChange={this.onTimeChange}
                                value={liveness_keep_time}
                                size='small'
                                min={0}
                                max={5}
                            /> 秒
                        </div>
                    </div>
                </div>}
                <Modal
                    visible={isShowTextModal}
                    title={modalTitle}
                    onCancel={this.onCloseTextModal}
                    onOk={this.onSaveText}
                >
                    <Form>
                        {
                            cacheAction && renderFormMap[cacheAction].map((item,index)=>{
                                return (
                                    <FormItem
                                        key={index}
                                        label={item.label}
                                    >
                                        {getFieldDecorator(item.key,{
                                            rules:item.rules
                                        })(
                                            item.multi ? <TextArea autosize={{minRows: 3, maxRows: 3}} placeholder={item.placeholder}/>:<Input
                                                placeholder={item.placeholder}
                                            />
                                        )}
                                    </FormItem>
                                );
                            })
                        }
                    </Form>
                </Modal>
            </div>
        );
    }

}
export default Form.create()(ItemLiveInterfaceTips);



// WEBPACK FOOTER //
// ./src/pages/SDKLiveness/ItemLiveInterfaceTips.js